import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import "./index.scss";

const { Title } = Typography;

interface AILoaderProps {
  isAILoaderLoading: boolean;
  AILoaderMessage: string | null;
}

const AILoader: React.FC<AILoaderProps> = ({
  AILoaderMessage,
  isAILoaderLoading,
}) => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isAILoaderLoading) return;

    const handleMouseMove = (e: MouseEvent) => {
      setCursorPosition({ x: e.clientX, y: e.clientY });
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isAILoaderLoading]);

  if (!isAILoaderLoading) return null;

  return (
    <div className="ai_loader_container">
      <div
        className="cursor-shine"
        style={{
          left: cursorPosition.x - 75,
          top: cursorPosition.y - 75,
        }}
      />
      <div className="ai_loader_content">
        <div className="ai-image-wrapper">
          <img
            src="/icons/ai-stars.svg"
            alt="ai-icon"
            className="ai-icon"
          />
        </div>
        <Title level={4} className="ai-loader-text">
          {AILoaderMessage ? AILoaderMessage : "Loading, please wait..."}
        </Title>
      </div>
    </div>
  );
};

export default AILoader;
